module.exports = __webpack_public_path__ + "img/verified.ba1dcb97.png";